import { Flex } from 'antd';

export const RolesToolTip = ({ roles }) => {
  return (
    <>
      {roles?.length > 0 &&
        roles?.map((role, index) => {
          return (
            <div key={index}>
              <Flex align="start">
                <span>{role?.name}</span>
              </Flex>
            </div>
          );
        })}
    </>
  );
};
